import { Token } from "@siteimprove/alfa-css";
import { None } from "@siteimprove/alfa-option";
import { Parser } from "@siteimprove/alfa-parser";
import { Specificity } from "../../specificity.js";
import { Selector } from "../selector.js";
import { parseNamespace } from "./parser.js";
const { left, map, option } = Parser;
/**
 * {@link https://drafts.csswg.org/selectors/#universal-selector}
 *
 * @public
 */
export class Universal extends Selector {
    static of(namespace) {
        return new Universal(namespace);
    }
    static _empty = new Universal(None);
    static empty() {
        return this._empty;
    }
    _namespace;
    constructor(namespace) {
        super("universal", Specificity.empty());
        this._namespace = namespace;
    }
    get namespace() {
        return this._namespace;
    }
    matches(element) {
        if (this._namespace.isNone() || this._namespace.includes("*")) {
            return true;
        }
        return element.namespace.equals(this._namespace);
    }
    equals(value) {
        return (value instanceof Universal && value._namespace.equals(this._namespace));
    }
    *[Symbol.iterator]() {
        yield this;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            namespace: this._namespace.getOr(null),
        };
    }
    toString() {
        const namespace = this._namespace
            .map((namespace) => `${namespace}|`)
            .getOr("");
        return `${namespace}*`;
    }
}
/**
 * @public
 */
(function (Universal) {
    function isUniversal(value) {
        return value instanceof Universal;
    }
    Universal.isUniversal = isUniversal;
    /**
     * {@link https://drafts.csswg.org/selectors/#typedef-type-selector}
     */
    Universal.parse = map(left(option(parseNamespace), Token.parseDelim("*")), (namespace) => Universal.of(namespace));
})(Universal || (Universal = {}));
//# sourceMappingURL=universal.js.map